// removed by extract-text-webpack-plugin
module.exports = {"videoContainer":"FullScreenVideo__videoContainer___13Wg4","closeButton":"FullScreenVideo__closeButton___1o9y0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FullScreenVideo/FullScreenVideo.scss
// module id = 1493
// module chunks = 0